import {
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  inMemoryPersistence,
  setPersistence,
  signInWithEmailAndPassword,
} from "firebase/auth";
import "react-toastify/dist/ReactToastify.css";
import { AuthErrorMessages } from "./AuthErrorMessages";
import SeedBusinessRecord from "./SeedBusinessRecord";
import SeedUserRole from "./SeedUserRole";
import { browserName, browserVersion } from "react-device-detect";
import axios from "axios";
import { isMobile } from "react-device-detect";
import { setDoc, doc, Timestamp } from "firebase/firestore";
import { db } from "../../firebase";
import getJsUTC from "../../helpers/getJsUTC";
export default async (Email, Password, persisted) => {
  return await setPersistence(
    getAuth(),
    persisted ? browserLocalPersistence : browserSessionPersistence
  ).then(async () => {
    return await signInWithEmailAndPassword(getAuth(), Email, Password)
      .then(async (userCredential) => {
        const { uid } = userCredential.user;

        /**
         * Get business information and seed in localstorage
         */
        await SeedBusinessRecord(uid);

        /**
         * Get user role and seed in localstorage
         */
        await SeedUserRole(uid);
        const userId = getAuth()?.currentUser?.uid;
        try {
          const res = await axios.get("https://geolocation-db.com/json/");
          const ip = res.data.IPv4;
          const deviceDataCollection = await doc(
            db,
            "users",
            userId,
            "devices_logged_in",
            ip
          );
          await setDoc(deviceDataCollection, {
            browser_name: browserName,
            browser_version: browserVersion,
            status: "login",
            ip: ip,
            logged_in_date: Timestamp.fromDate(new Date(getJsUTC())),
            logged_in_device: isMobile ? "Mobile" : "Desktop",
          });
        } catch (error) {
          console.log(error);
        }
        return userCredential.user;
      })
      .catch((error) => {
        console.log(error.code);
        AuthErrorMessages(error.code);
        return false;
      });
  });
};
